import { render, staticRenderFns } from "./columnTable.vue?vue&type=template&id=2e0e009e&scoped=true&"
import script from "./columnTable.vue?vue&type=script&lang=js&"
export * from "./columnTable.vue?vue&type=script&lang=js&"
import style0 from "./columnTable.vue?vue&type=style&index=0&id=2e0e009e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0e009e",
  null
  
)

export default component.exports